import { Outlet } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { MobileCallBar } from "@/components/MobileCallBar";
import { ScrollToTop } from "@/components/ScrollToTop";

export const Layout = () => (
  <div className="flex min-h-screen flex-col bg-ink">
    <ScrollToTop />
    <Navbar />
    <main className="flex-1">
      <Outlet />
    </main>
    <Footer />
    <div aria-hidden className="h-[76px] md:hidden" />
    <MobileCallBar />
  </div>
);
